class Socket {
  constructor ({ host, adminId, onmessageListener }) {
    this.host = host
    this.socket = null
    this.adminId = adminId
    this.sendAwait = [] // 记录socket状态readyState == 1之前需要发送的数据
    // 定义socket心跳、重连相关配置
    this.config = {
      time: 25000, // 心跳时间间隔
      timer: null, // 心跳定时器
      reconnectMaxTime: 20, // 最大重连次数
      connectTime: 0, // 重连次数
      reconnectTime: 5000, // 重连间隔时间
      reconnectTimer: null, // 重连间隔延迟定时器
      offLineTimer: null // 判断离线的定时器
    }
    this.noticeSign = '' // 发送消息的验证信息
    if (typeof onmessageListener === 'function') {
      this.onmessageListener = onmessageListener
    } else {
      this.onmessageListener = function () {}
    }
  }
  // 发送心跳
  ping () {
    this.send(JSON.stringify({
      ping: '1',
      noticeSign: this.noticeSign
    }))
  }
  // 开始发送心跳
  startHeart () {
    this.ping()
    this.config.timer = setInterval(() => {
      this.ping()
    }, this.config.time)
  }
  // 结束心跳
  stop () {
    clearTimeout(this.config.timer)
  }
  login () {
    if (this.adminId || this.adminId === 0) {
      let ws = new WebSocket(this.host)
      this.socket = ws
      ws.onopen = () => {
        let info = localStorage.getItem('user_info');
        this.noticeSign = JSON.parse(info).noticeSign
        // 发送身份认证
        this.send(JSON.stringify({
          adminId: this.adminId,
          noticeSign: this.noticeSign
        }))
        // 重置重连次数，清除重连定时
        this.config.connectTime = 0
        clearTimeout(this.config.reconnectTimer)
        this.config.reconnectTimer = null
        // 开始心跳
        this.startHeart()
        this.offLineTimer = setTimeout(() => {
          this.onclose()
        }, this.config.time * 4)
      }
      ws.onmessage = (e) => {
        console.log(e.data, '====socket onmessage=====')
        let data
        try {
          data = JSON.parse(e.data)
        } catch (err) {
          throw err
        }
        this.onmessage(data)
      }
      ws.onerror = (err) => {
        console.log(err)
      }
    }
  }
  send (message) {
    if (this.socket.readyState != 1) {
      this.sendAwait.push(message)
    } else {
      if (this.sendAwait.length) {
        this.sendAwait.forEach(item => {
          this.socket.send(item)
        })
      }
      this.socket.send(message)
    }
  }
  onmessage (data) {
    if (data.msg) {
      this.onmessageListener(data)
    }
    // 根据接收的pong判断是否断线
    // 根据心跳时间判断，连续三次心跳都没有收到pong回应，则判断断线，进行重连
    if (data.pong == 1) {
      clearTimeout(this.offLineTimer)
      this.offLineTimer = setTimeout(() => {
        this.onclose()
      }, this.config.time * 4)
    }
  }
  onclose (e) {
    console.log('websocket closed')
    // 停止心跳
    this.stop()
    this.socket.close()
    // 若重连次数大于最大重连次数，则不再重连
    if (this.config.connectTime > this.config.reconnectMaxTime) {
      console.log('reconnectTime overmuch')
      return
    }
    console.log('websocket reconneting')
    // 累计重连次数
    this.config.connectTime++
    // 间隔固定时间后重连
    this.config.reconnectTimer = setTimeout(() => {
      this.login()
    }, this.config.reconnectTime)
  }
}
export default Socket



// WEBPACK FOOTER //
// ./src/websocket.js